import useThemeStore from "../../store/useThemeStore";
import { isAppDark } from "../../utils/theme";

const DARK_SHIMMER = { from: "#2a2a32", via: "#3f3f4a", to: "#2a2a32" };

/** Resolves shimmer mode for shimmer-effects-react (`light` | `dark`). */
export function useShimmerMode() {
  const isDark = useThemeStore((state) => state.isDark);
  return isAppDark(isDark) ? "dark" : "light";
}

/**
 * Light mode keeps the library default (`mode="light"`).
 * Dark mode uses custom greys so loaders never stay white.
 */
export function useShimmerThemeProps(mode) {
  const themeMode = useShimmerMode();
  const resolved = mode ?? themeMode;
  if (resolved === "custom") {
    return { mode: "custom" };
  }
  if (resolved === "dark") {
    return { mode: "custom", ...DARK_SHIMMER };
  }
  return { mode: "light" };
}
